var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.language==='简体中文')?_c('div',[(_vm.screenWidth>600)?_c('bottom_web'):_c('bottom_h5')],1):_vm._e(),(_vm.$store.state.language==='TIẾNG VIỆT')?_c('div',[(_vm.screenWidth>600)?_c('bottom_web_lang'):_c('bottom_h5_lang')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }